/**
 * Created by robert.lavoie on 6/14/17.
 */

import { Component, Input, ChangeDetectionStrategy, OnChanges, SimpleChanges } from '@angular/core';

// Models
import { Site, LogoPosition } from '../../models';

// Utils
import { AlternateTypeColors } from '../../utils/colorFormat';

/**
 *
 * @class
 * CustomerSiteIntroComponent
 *
 * @description
 * This component lives at the the top of every customer site page and
 * includes an optional background image, logo and copy
 *
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: 'customer-site-intro.component.html',
  selector: 'customer-site-intro',
  styleUrls: ['./customer-site-intro.component.scss'],
})
export class CustomerSiteIntroComponent implements OnChanges {

  // The current site we are within
  @Input() site: Site;

  // Whether or not the site is read only
  @Input() isReadOnly: boolean = true;

  // Whether or not to show the logo on this component
  showLogo: boolean;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.site) {
      // Define valid states
      // tslint:disable-next-line:prefer-array-literal
      const validStates: Array<string> = [
        LogoPosition.INTRO,
        LogoPosition.HEADER_AND_INTRO,
      ];

      // If the theme is one of our valid states, show the logo
      const site = changes.site.currentValue as Site;
      this.showLogo = validStates.indexOf(site.theme.logoPosition) >= 0 ? true : false;
    }
  }

  /**
   * Builds a style object for the intro component based around the current site settings
   */
  getBackgroundColorStyle() {
    // Return if there is no background color
    if (!this.site.siteIntro.backgroundColor) return false;

    // Return false if a background image is set
    if (this.site.siteIntro.backgroundImage) return false;

    // Otherwise build the style object and return it
    const color = this.site.siteIntro.backgroundColor;
    const style = {};
    style['background-color'] = AlternateTypeColors[color] ? AlternateTypeColors[color] : this.site.theme[color];

    return style;
  }

}
